import { render, staticRenderFns } from "./gdpr.vue?vue&type=template&id=9262d034&scoped=true&"
import script from "./gdpr.vue?vue&type=script&lang=js&"
export * from "./gdpr.vue?vue&type=script&lang=js&"
import style0 from "./gdpr.vue?vue&type=style&index=0&id=9262d034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9262d034",
  null
  
)

export default component.exports